module.exports = __webpack_public_path__ + "static/media/img_9.471999f6.png";